import templateUrl from './asn.view.html'

/**
 * Asn detail Report route
 *
 * @namespace routes.ReportAsnView
 * @type {TmrRoute}
 */
export const route = {
  name: 'report.asns.view',
  label: 'REPORT.ASNS.VIEW.TITLE',
  url: '/asns/:id?parcel',
  component: 'tmrReportAsnView',
  accessControl: 'TmrShippingOperationsLegacyAccessControl',
  data: {
    capabilities: ['Resource.view', 'Resource.Asn.view'],
  },
  abstract: false,
  paging: true,
  params: {
    parcel: null,
  },
  resolve: {
    parcels: /*@ngInject*/ ($transition$, Parcel, TmrPaging, resource) =>
      Parcel.pagedQuery(
        TmrPaging.resolveParams($transition$, { 'asn.id': resource.id })
      ),
    parcelsCount: /*@ngInject*/ (Parcel, resource) =>
      Parcel.count({ 'asn.id': resource.id }),
    parcel: /*@ngInject*/ ($transition$, parcels) => {
      let id = $transition$.params().parcel
      if (id)
        return parcels.$promise.then(() => {
          let parcel = parcels.find(parcel => parcel.id == id)
          if (parcel) return parcel.$get()
        })
    },
    drilldown: /*@ngInject*/ (resource, parcel) => {
      let drilldown = [{ label: resource.$getLabel() }]
      if (parcel && parcel.id)
        drilldown.push({ param: 'parcel', label: parcel.$getLabel() })
      return drilldown
    },
  },
}

/**
 * Component for {@link routes.tmrReportAsnView Asns Report route}
 *
 * @type {ngComponent}
 */
export const tmrReportAsnView = {
  ngType: 'component',
  templateUrl,
  bindings: {
    resource: '<',
    parcels: '<',
    parcelsCount: '<',
    parcel: '<?',
    drilldown: '<?',
    currentPage: '<',
    pageSize: '<',
  },
}
